import axios from "axios";
import Config from "../../../config";
import { authHeaders } from 'src/actions/authHeaders';

// Carrega as listas de domínio do Imoview usadas na config de Envio de
// Atendimento: unidades (só precisa da chave), mídias e tipos de atendimento
// (exigem login da conta de serviço). Credenciais vão no body para permitir
// carregar antes de salvar o agente.
const v2_actionListasImoview = (agenteId, { email, senha, token } = {}) => {
    return axios({
        headers: authHeaders(),
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/agentes/${agenteId}/imoview/listas`,
        data: { email, senha, token },
    });
};

export default v2_actionListasImoview;
